import React from "react";
import { Input, Table, Tooltip } from "antd";

import { FREQUENCY_GROUPS } from "./sampleData";

/**
 * Frequency, at the grain carriers actually quote it.
 *
 * Modelled on Manulife's own frequency table: one row per procedure GROUP with
 * separate adult and child limits. The grain is finer than the coverage family
 * on purpose — Polishing, Prophylaxis and Preventative Scaling share a family
 * and a percentage but each carry their own limit, so folding them together
 * would lose the very thing this table exists to say.
 *
 * Shared by both surfaces: editable during intake, read-only on display.
 */
export default function FrequencyTable({ values, onChange, editable }) {
  function setField(key, field, value) {
    if (!onChange) return;
    const next = Object.assign({}, values);
    next[key] = Object.assign({}, next[key] || {}, { [field]: value });
    onChange(next);
  }

  const rows = FREQUENCY_GROUPS.map(function (g) {
    const v = values[g.key] || {};
    return Object.assign({}, g, v, { key: g.key, codeList: (g.codes || []).join(", ") });
  });

  const columns = [
    {
      title: "Procedure group",
      dataIndex: "name",
      render: function (_, row) {
        return (
          <div>
            <span className="bw-doc-family">{row.name}</span>
            <Tooltip title={row.family}>
              <div className="bw-doc-codes">{row.codeList} · {row.family}</div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Adult frequency",
      dataIndex: "adult",
      width: editable ? 260 : 250,
      render: function (v, row) {
        if (!editable) return v ? v : <span className="bw-notdue">—</span>;
        return (
          <Input size="small" placeholder="2 time(s) every 1 year(s)" value={v || ""}
            onChange={function (e) { setField(row.key, "adult", e.target.value); }} />
        );
      },
    },
    {
      title: "Child frequency",
      dataIndex: "child",
      width: editable ? 260 : 250,
      render: function (v, row) {
        // Highlighted only when it DIFFERS from the adult limit — the whole
        // reason the column exists, and easy to miss when most rows match.
        const differs = v && row.adult && v !== row.adult;
        if (!editable) {
          if (!v) return <span className="bw-notdue">—</span>;
          return differs ? <span className="bw-doc-differs">{v}</span> : v;
        }
        return (
          <Input size="small" placeholder="same as adult unless stated" value={v || ""}
            onChange={function (e) { setField(row.key, "child", e.target.value); }} />
        );
      },
    },
  ];

  return (
    <Table className={editable ? "" : "bw-doc-table"} size={editable ? "small" : "middle"}
      rowKey="key" columns={columns} dataSource={rows} pagination={false} tableLayout="fixed" />
  );
}
